import Lesson from 'models/Lesson';
import React from 'react';

interface LessonContextType {
  lesson: Lesson | undefined;
}

export default React.createContext<LessonContextType>({ lesson: undefined });
